
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import dynamic from 'next/dynamic';
import React from 'react';
import { LoaderScreen } from '@/components/elements/LoaderScreen';
import { LandingLayout } from '@/components/layouts/LandingLayout';
import { TranslationProvider } from '@/context/translation';
import { createNonLocalizedPageGetServerSidePropsWithTranslations, type NonLocalizedPageWithTranslationsProps, } from '@/helpers/createNonLocalizedPageGetServerSideProps';
const FurnitureImagesLanding = dynamic(async () => await import('@/templates/Landing/FurnitureImages/FurnitureImagesLanding'), {
    loading: LoaderScreen,
});
const index: React.FC<NonLocalizedPageWithTranslationsProps> = ({ locale, translations, }) => {
    return (<TranslationProvider locale={locale} translations={translations}>
			<LandingLayout title='Effortless AI Furniture Photography – Create Stunning Product Images in Seconds | Lift' description='Lift makes it easy to create polished, professional furniture images for e-commerce and marketplaces. Instantly remove backgrounds, enhance visuals, and optimize your listings to boost engagement and sales.' ogTitle='Lift: Instantly Create Marketplace-Ready Furniture Photos with AI' ogDescription='Create flawless product photos for furniture and home décor with Lift’s AI tools. Boost brand perception, drive conversions, and save hours of editing time with professional-grade visuals generated in seconds.'>
				<FurnitureImagesLanding />
			</LandingLayout>
		</TranslationProvider>);
};
export default index;
const getServerSideProps = createNonLocalizedPageGetServerSidePropsWithTranslations('/for-businesses/furniture-images', 'furniture-images');

    async function __Next_Translate__getServerSideProps__1a1a20bb8ba__(ctx) {
      const res = await getServerSideProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/for-businesses/furniture-images/index',
            loaderName: 'getServerSideProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import(`@next-translate-root/locales/${l}/${n}`).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getServerSideProps__1a1a20bb8ba__ as getServerSideProps }
  